export default "__VITE_ASSET__b3118885__"